"use client";
import {
    ICM_MAIL,
    // ICM_MAIL_SUPPORT,
    ICM_NAME_FULL,
    ICM_REFER_AMAZON_BENEFIT,
    ICM_REFER_BENEFIT,
    ICM_REFERRER_AMAZON_BENEFIT,
    ICM_REFERRER_BENEFIT,
    INCREDUNLISTED,
} from "@/app/utils/constants";
import Breadcrumb, { type BreadcrumbPath } from "@/app/components/breadcrumb.client";
import React from "react";

const termsBreadcrumbPaths: BreadcrumbPath[] = [
    { label: "Home", route: "/" },
    { label: "Terms & Conditions" },
];

const TermsAndConditions = () => {
    return (
        <section
            id="main-section"
            className="md:px-auto mx-auto bg-neutral-50 px-6 pb-14 pt-8 md:container md:bg-transparent md:pb-[120px] md:pt-0"
        >
            <Breadcrumb paths={termsBreadcrumbPaths} />
            <h1 id="heading" className="mb-4 text-4xl font-semibold md:mb-8 md:text-6xl">
                Terms of Use
            </h1>
            {/* Pre IPO Offer */}
            <div className="mb-12">
                <h2 className="tracking--0.48px mb-4 text-4xl font-semibold leading-10 md:text-6xl md:leading-[55px]">
                    Pre IPO | Unlisted Shares User offer: ₹200 Amazon Voucher and{" "}
                    {ICM_REFER_BENEFIT}% offer benefit on 1st successful transaction – Terms and
                    Conditions
                </h2>

                <p className="mb-4 text-lg font-semibold text-black">User Benefits:</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            Eligibility: This offer is valid for both New and Existing users who
                            have signed up on {ICM_NAME_FULL}. This is applicable for users signing
                            up on the {ICM_NAME_FULL} Pre IPO | Unlisted Shares platform.
                        </li>
                        <li className="mb-1">
                            Offer benefit of ₹200 Amazon Voucher and {ICM_REFER_BENEFIT}% offer
                            benefit transaction is applicable only for 1st transaction.
                        </li>
                        <li className="mb-1">
                            Product Type: Offer is applicable on Pre IPO | Unlisted Shares only.
                        </li>
                        <li className="mb-1">
                            Minimum requirement: It is applicable even on purchase of just 1 share.
                        </li>
                        <li className="mb-1">
                            Benefits: Upon meeting the eligibility criteria and successfully
                            purchasing Unlisted Shares, you will receive a ₹
                            {ICM_REFER_AMAZON_BENEFIT} Amazon gift voucher on your registered email
                            ID. Amazon vouchers issued will carry 6-7 year validity from the date of
                            issue.
                        </li>
                    </ul>
                </div>

                <p className="mb-4 text-lg font-semibold text-black">Referrer Benefits:</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            Referrer will earn referral benefit for every new referral.
                        </li>
                        <li className="mb-1">
                            Referrer will receive ₹{ICM_REFERRER_AMAZON_BENEFIT} Amazon Voucher and{" "}
                            {ICM_REFERRER_BENEFIT}% offer benefit on 1st successful transaction by
                            his/her referral in Pre - IPO || Unlisted Shares
                        </li>
                        <li className="mb-1">
                            Referrer will receive <s>0.25%</s> {ICM_REFERRER_BENEFIT}% transaction
                            benefit from 2nd successful transaction onwards completed by his/her
                            referral in Pre - IPO || Unlisted Shares.
                        </li>
                        <li className="mb-1">
                            Referrer will receive a maximum of ₹10,000 per referral.
                        </li>
                        <li className="mb-1">Referrer can refer any number of referrals.</li>
                        <li className="mb-1">
                            The minimum transaction amount for the referee to avail this offer is
                            ₹1,000.
                        </li>
                        <li className="mb-1">
                            ETA Fintech Private Limited reserves the right at any time, without
                            prior notice and without assigning any reason whatsoever to
                            add/modify/alter/change and/or withdraw this offer at any time at its
                            sole discretion.
                        </li>
                        <li className="mb-1">
                            Customer unequivocally and irrevocably agrees that in case of any
                            dispute, the decision of ETA Fintech Private Limited will be final and
                            binding.
                        </li>
                    </ul>
                </div>

                <div id="Influencers-Affiliates" className="">
                    <p className="mb-1 text-lg font-semibold text-black">
                        Content Guidelines for Influencers & Affiliates: Unlisted Shares by{" "}
                        {ICM_NAME_FULL}
                    </p>
                    <p className="mb-4 text-lg font-semibold text-black">
                        (For Social Media, Blogs, Videos, and Other Public Platforms)
                    </p>
                    <p className="mb-4 text-base text-black">
                        When creating content related to unlisted shares, it is crucial to maintain
                        transparency, accuracy, and regulatory compliance. The following rules are
                        non-negotiable and are designed to protect retail investors, safeguard the
                        brand, and ensure legal compliance.
                    </p>
                    <div className="mb-8 text-base">
                        <ul className="mb-4 ml-4 list-decimal">
                            <li className="mb-1">
                                <p className="mb-2 ml-1 text-black">
                                    Avoid Misleading Investment Promises
                                </p>
                                <div className="mb-6 text-base text-neutral-500">
                                    <ul className="mb-4 ml-5 list-disc">
                                        <li className="mb-1">
                                            Do not guarantee returns or use terms like &quot;high
                                            growth&quot; potential, &quot;multibagger,&quot;
                                            &quot;guaranteed returns,&quot; or &quot;risk-free
                                            investment.&quot;
                                        </li>
                                        <li className="mb-1">
                                            Avoid hype-driven phrases such as &quot;next big
                                            thing,&quot; &quot;once-in-a-lifetime opportunity,&quot;
                                            or &quot;sure shot.&quot;
                                        </li>
                                        <li className="mb-1">
                                            Do not compare unlisted shares to listed stocks unless
                                            clearly stating differences in risk, volatility, and
                                            liquidity.
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li className="mb-1">
                                <p className="mb-2 ml-1 text-black">
                                    Maintain Transparency on Risks & Performance
                                </p>
                                <div className="mb-6 text-base text-neutral-500">
                                    <ul className="mb-4 ml-5 list-disc">
                                        <li className="mb-1">
                                            Avoid making forward-looking statements about IPO
                                            timelines, price appreciation, or exit opportunities.
                                        </li>
                                        <li className="mb-1">
                                            Clearly state that unlisted shares are illiquid and
                                            subject to higher risk, and investors should do their
                                            own due diligence.
                                        </li>
                                        <li className="mb-1">
                                            If citing past returns, add a disclaimer: &quot;Past
                                            performance is not indicative of future outcomes.&quot;
                                        </li>
                                        <li className="mb-1">
                                            Present a balanced narrative—highlight both
                                            opportunities and challenges.
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li className="mb-1">
                                <p className="mb-2 ml-1 text-black">
                                    Regulatory & Compliance Guidelines
                                </p>
                                <div className="mb-6 text-base text-neutral-500">
                                    <ul className="mb-4 ml-5 list-disc">
                                        <li className="mb-1">
                                            Do not imply or falsely claim SEBI/NSE/BSE approvals or
                                            suggest regulatory endorsement.
                                        </li>
                                        <li className="mb-1">
                                            If mentioning a potential IPO, add: &quot;IPO is not
                                            guaranteed, and timelines may change.&quot;
                                        </li>
                                        <li className="mb-1">
                                            Never promote unlisted shares as substitutes for
                                            regulated financial instruments like mutual funds,
                                            insurance, or fixed deposits.
                                        </li>
                                        <li className="mb-1">
                                            Affiliates must comply with advertising, consumer
                                            protection, and data privacy laws.
                                        </li>
                                        <li className="mb-1">
                                            All content creators are legally liable for the claims
                                            made in their content.
                                        </li>
                                        <li className="mb-1">
                                            The company reserves the right to remove or report any
                                            content that violates these terms and terminate the
                                            partnership immediately.
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li className="mb-1">
                                <p className="mb-2 ml-1 text-black">
                                    Responsible Content & Data Accuracy
                                </p>
                                <div className="mb-6 text-base text-neutral-500">
                                    <ul className="mb-4 ml-5 list-disc">
                                        <li className="mb-1">
                                            Do not use fake reviews, unverified testimonials, or
                                            misleading headlines.
                                        </li>
                                        <li className="mb-1">
                                            Always cite sources for numbers, valuations, or
                                            claims—acceptable sources include annual reports,
                                            company filings, SEBI disclosures, and reputable media.
                                        </li>
                                        <li className="mb-1">
                                            Avoid cherry-picking data or projecting unlisted share
                                            valuations without context.
                                        </li>
                                        <li className="mb-1">
                                            Do not use terms like &quot;market cap&quot; or
                                            &quot;valuation&quot; unless based on disclosed,
                                            credible documentation.
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li className="mb-1">
                                <p className="mb-2 ml-1 text-black">
                                    Mandatory Disclaimers & Financial Responsibility
                                </p>
                                <p className="mb-2 ml-1 text-black">
                                    All content must include the following disclaimer:
                                </p>
                                <div className="mb-6 text-base text-neutral-500">
                                    <ul className="mb-4 ml-5 list-disc">
                                        <li className="mb-1">
                                            &quot;This communication is for informational purposes
                                            only and does not constitute investment advice or a
                                            recommendation. Investments in unlisted shares are
                                            subject to market risks. Please consult a
                                            SEBI-registered advisor before investing.&quot;
                                        </li>
                                        <li className="mb-1">
                                            Do not make buy/sell recommendations unless you are a
                                            registered investment advisor, and in such cases, ensure
                                            proper disclosures and risk warnings.
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li className="mb-1">
                                <p className="mb-2 ml-1 text-black">
                                    Brand Usage, Platforms & Approval
                                </p>
                                <div className="mb-6 text-base text-neutral-500">
                                    <ul className="mb-4 ml-5 list-disc">
                                        <li className="mb-1">
                                            Do not use the {ICM_NAME_FULL} name, logo, or brand
                                            identity without prior written approval.
                                        </li>
                                        <li className="mb-1">
                                            Do not create paid promotions, paid influencer posts, or
                                            sponsored ads using our name or unlisted share names
                                            without formal review and sign-off.
                                        </li>
                                        <li className="mb-1">
                                            All content (posts, videos, blogs, scripts) must be
                                            submitted to the company for review and approval before
                                            publishing.
                                        </li>
                                        <li className="mb-1">
                                            Do not use high-pressure tactics like &quot;only a few
                                            slots left&quot; or &quot;last chance&quot; unless
                                            explicitly provided by the company.
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li className="mb-1">
                                <p className="mb-2 ml-1 text-black">
                                    Legal Safeguards & Monitoring
                                </p>
                                <p className="mb-2 ml-1 text-black">
                                    The company will periodically monitor affiliate and influencer
                                    content for compliance. Any violations may lead to:
                                </p>
                                <div className="mb-4 text-base text-neutral-500">
                                    <ul className="mb-4 ml-5 list-disc">
                                        <li className="mb-1">
                                            Immediate termination of the partnership
                                        </li>
                                        <li className="mb-1">
                                            Reporting to regulators or legal action
                                        </li>
                                        <li className="mb-1">
                                            Blacklisting from future collaborations
                                        </li>
                                    </ul>
                                </div>
                                <p className="-ml-3 mb-4 text-black">
                                    Affiliates are advised to retain content history for audit and
                                    compliance purposes for a minimum of 6 months.
                                </p>
                            </li>

                            <li className="mb-1 list-none">
                                <p className="-ml-3 mb-2 text-black">
                                    ✅&nbsp;&nbsp;Company&rsquo;s Right to Determine Compliance
                                </p>
                                <div className="mb-6 text-base text-neutral-500">
                                    <ul className="mb-4 ml-5 list-disc">
                                        <li className="mb-1">
                                            The company reserves the sole right to determine whether
                                            any content, claim, or representation violates any
                                            guidelines, regulatory expectations, or brand standards.
                                        </li>
                                        <li className="mb-1">
                                            Any content found to be non-compliant, misleading, or
                                            reputationally risky—at the company&rsquo;s
                                            discretion—must be removed or revised upon request.
                                        </li>
                                        <li className="mb-1">
                                            Failure to comply with such requests may result in
                                            immediate termination and further legal action, if
                                            necessary.
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li className="mb-1 list-none">
                                <p className="-ml-3 mb-2 text-black">
                                    ✅&nbsp;&nbsp;Your Responsibility
                                </p>
                                <div className="mb-6 text-base text-neutral-500">
                                    <ul className="mb-4 ml-5 list-disc">
                                        <li className="mb-1">
                                            By engaging in content creation or affiliate activity
                                            with us, you acknowledge and agree to follow these
                                            guidelines in full.
                                        </li>
                                        <li className="mb-1">
                                            Violations, whether intentional or accidental, will have
                                            legal and reputational consequences.
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="mb-12">
                <h2 className="tracking--0.48px mb-4 text-4xl font-semibold leading-10 md:text-6xl md:leading-[55px]">
                    Terms and Conditions for Liquidation Program
                </h2>

                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            We strongly advise investors not to approach Unlisted Shares with a
                            trading mindset or the expectation of short-term exits.
                        </li>
                        <li className="mb-1">
                            These investments are best suited for those with a long-term horizon.
                            Unlisted shares typically have limited liquidity, especially for smaller
                            quantities. Finding a buyer and executing a transfer can be
                            operationally challenging. Events such as an IPO are often the more
                            natural exit routes for such investments. Do note that your investment
                            would be locked in for 6 months from the date of the IPO.
                        </li>
                        <li className="mb-1">
                            That said, we understand that exceptional or unforeseen circumstances
                            may arise where you need to liquidate your holdings earlier. If you wish
                            to explore a sale, you can write to us at{" "}
                            <a href={"mailto:" + ICM_MAIL} className="text-blue-500 underline">
                                {ICM_MAIL}
                            </a>{" "}
                            with the following details:
                        </li>
                        <li className="mb-1">
                            Full Name:
                            <br />
                            Registered Email ID (with {ICM_NAME_FULL})
                            <br />
                            PAN Number
                            <br />
                            Name of the Company <br />
                            Quantity of Shares to Sell <br />
                        </li>
                        <li className="mb-1">
                            Once we receive your request, our team will get in touch and attempt to
                            find a buyer on a best-effort basis. If we are successful, we’ll quote
                            you a price for your shares.
                        </li>
                    </ul>
                    <p className="mb-4 text-lg font-semibold text-black">
                        <span className="text-black">A few important points to keep in mind:</span>
                    </p>
                    <div className="mb-8 text-base text-neutral-500">
                        <ul className="mb-4 ml-6 list-disc">
                            <li className="mb-1">
                                The quoted price may be up to ~5–7% lower than the current platform
                                price, depending on demand and quantity.
                            </li>
                            <li className="mb-1">
                                For some stocks with very low demand, we may not be able to
                                facilitate a buyback.
                            </li>
                            <li className="mb-1">
                                You are always free to find your own buyer outside of our platform
                                as well.
                            </li>
                            <li className="mb-1">
                                There is a high probability that we may not be able to offer this
                                service for value less than ₹5,000.
                            </li>
                            <li className="mb-1">
                                The total transfer process may take upto 1 month from the request
                                being initiated
                            </li>
                        </ul>
                    </div>
                    <div className="mb-8 text-base text-neutral-500">
                        <ul className="mb-4 ml-6 list-disc">
                            <li className="mb-1">
                                <span className="text-black">
                                    If you agree to the quoted price, here&apos;s how the process
                                    works:
                                </span>
                            </li>
                            <li className="mb-1">
                                <span className="text-black">Deal Sheet:</span> We will send you a
                                document with all transaction details.
                            </li>
                            <li className="mb-1">
                                <span className="text-black">Transfer of Shares:</span> You’ll need
                                to transfer the shares from your demat account to ours. Our team
                                will guide you through this step.
                            </li>
                            <li className="mb-1">
                                <span className="text-black">Fund Transfer:</span> Once we receive
                                the shares, we’ll confirm the receipt and transfer the funds to your
                                registered bank account.
                            </li>
                            <li className="mb-1">
                                <span className="text-black">⚠️ Please Note:</span> If we receive
                                the shares after the price validity period, and there has been a
                                significant change in the stock price, the original offer may be
                                revised.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* FD New User Offer */}
            {/* <div className="mb-12">
                <h3 className="tracking--0.48px mb-4 text-4xl font-semibold leading-10 md:text-6xl md:leading-[55px]">
                    FD New User Offer: ₹250 Amazon Voucher - Terms and Conditions
                </h3>

                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            Eligibility: New user: This offer is only valid for users who have
                            signed up on {ICM_NAME_FULL} on or after 13th March 2024. This is
                            applicable for users signing up on the {ICM_NAME_FULL} FD platform only.
                        </li>
                        <li className="mb-1">
                            FD Type: Offer is applicable on bank FD only. This offer is not
                            applicable on NBFC/Corporate FD due to regulatory restrictions.
                        </li>
                        <li className="mb-1">
                            Minimum deposit amount: It is applicable for minimum deposit amount of
                            ₹5,000 and minimum tenure of 1 year.
                        </li>
                        <li className="mb-1">
                            Benefits: Upon meeting the eligibility criteria and successfully opening
                            a Bank FD, you will receive a ₹250 Amazon gift voucher on your
                            registered email ID. Only 60 days of booking an FD, provided there is no
                            premature withdrawal of the FD before that. Amazon vouchers issued will
                            carry a 1 year validity from the date of issue.
                        </li>
                        <li className="mb-1">
                            Only users who book their first Fixed Deposit and complete Video KYC for
                            the same on the {ICM_NAME_FULL} App will be eligible for the offer.
                        </li>
                        <li className="mb-1">Maximum benefit per user will not exceed Rs. 250.</li>
                        <li className="mb-1">A user will only get the voucher once.</li>
                        <li className="mb-1">
                            Offer is valid only for - Utkarsh Small Finance Bank, South Indian Bank,
                            slice small finance bank.
                        </li>
                        <li className="mb-1">
                            ETA Fintech Private Limited reserves the right at any time, without
                            prior notice and without assigning any reason whatsoever to
                            add/modify/alter/change and/or withdraw this offer at any time at its
                            sole discretion.
                        </li>
                        <li className="mb-1">
                            Customer unequivocally and irrevocably agrees that in case of any
                            dispute, the decision of ETA Fintech Private Limited will be final and
                            binding.
                        </li>
                        <li className="mb-1">
                            This offer is not applicable for users who already have an account with
                            the bank with which the FD is opened.
                        </li>
                    </ul>
                </div>
            </div> */}

            {/* {ICM_NAME_FULL} Pro */}
            {/* <div className="mb-12">
                <h3 className="tracking--0.48px mb-4 text-4xl font-semibold leading-10 md:text-6xl">
                    {ICM_NAME_FULL} Pro - Terms and Conditions
                </h3>

                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            Eligibility: New user: This offer is applicable for users who make a
                            cumulative deposit of FD sums in Fixed Deposits offered on{" "}
                            {ICM_NAME_FULL}
                            (banks or NBFCs).
                        </li>
                        <li className="mb-1">
                            Benefits: Upon investing ₹5 lakhs in FD on {ICM_NAME_FULL}, you will be
                            upgraded to {ICM_NAME_FULL} pro within 1 working days. You will receive
                            an email communicating the same to you.
                        </li>
                        <li className="mb-1">
                            Terms & conditions for the membership program:
                            <ul className="ml-6 list-disc">
                                <li>
                                    Customer should be a registered Customer of {ICM_NAME_FULL}.
                                </li>
                                <li>
                                    Customer should be of an age 18 years or above and of sound mind
                                    at the time of being a part of the contest & should have valid
                                    proof of identity and address.
                                </li>
                                <li>
                                    Employees of {ICM_NAME_FULL}, their immediate family members,
                                    {ICM_NAME_FULL} Affiliates, advisors, advertising/partner
                                    agencies are not eligible to enter the contest.
                                </li>
                                <li>
                                    Customer should be an individual legal resident of the Republic
                                    of India.
                                </li>
                                <li>
                                    Participation in the Offer is voluntary and free. Participation
                                    in the Offer will be construed as acceptance of the Terms &
                                    Conditions of the Offer and participant warrants that he/she is
                                    willing to be bound by the Terms & Conditions. By accepting the
                                    Terms & Conditions of this offer, Alpha Fintech Private Limited
                                    is not charging anything from the customer for their
                                    participation in the offer.
                                </li>
                                <li>
                                    The reward under no circumstances will be settled in Cash/cannot
                                    be transferred.
                                </li>
                                <li>
                                    This is an electronic record in terms of Information Technology
                                    Act, 2000, and the rules thereunder as applicable and the
                                    amended provisions pertaining to electronic records in various
                                    statutes as amended by the Information Technology Act, 2000.
                                    This electronic record is generated by a computer system and
                                    does not require any physical or digital signatures.
                                </li>
                                <li>
                                    Alpha Fintech Private Limited reserves the right at any time,
                                    without prior notice and without assigning any reason whatsoever
                                    to add/modify/alter/ change and/or withdraw this offer at any
                                    time at its sole discretion.
                                </li>
                                <li>
                                    Customer unequivocally and irrevocably agrees that in case of
                                    any dispute, the decision of Alpha Fintech Private Limited will
                                    be final and binding.
                                </li>
                                <li>
                                    The competent Court of Mumbai shall have the exclusive
                                    jurisdiction for any matter or dispute related to Alpha Fintech
                                    Private Limited.
                                </li>
                                <li>
                                    This offer/scheme shall be subjected to all applicable
                                    central/or state laws, rules and regulations
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div> */}

            {/* General Terms */}
            {/* <div className="mb-12">
                <h3 className="tracking--0.48px mb-4 text-4xl font-semibold leading-10 md:text-6xl">
                    Terms and Conditions for the Liquidation Program
                </h3>

                <div className="mb-8 text-base text-neutral-500">
                    <ol className="mb-4 ml-6 list-decimal">
                        <li className="mb-1">
                            &apos;Anytime Liquidity&apos; feature offers liquidity to investors only
                            after 21 days from their order processed date.
                        </li>

                        <li className="mb-1">
                            Cost of liquidity provided is 2% of the latest market to market price
                            per unit.
                        </li>
                    </ol>
                </div>
            </div> */}
            {/* <div className="mb-12">
                <h3 className="tracking--0.48px mb-6 text-4xl font-semibold leading-10 md:text-6xl">
                    For Corporate Bonds
                </h3>
                <p className="mb-4 font-semibold">
                    Please follow the steps for Liquidating your Bond. If any step is pending, the
                    liquidation will remain incomplete:
                </p>
                <p className="mb-4 text-neutral-500">
                    <span className="text-black">Step 1</span> - Enter the units that you want to
                    liquidate and click on &apos;Request Quote&apos;. You can liquidate any number
                    of units up to a maximum of the total free units available. You will now get an
                    OTP on your Mobile and Email. Input the OTP to confirm your request. Once
                    confirmed, your liquidation price will be finalized, and the liquidation price
                    will be frozen.
                </p>
                <p className="mb-4 text-neutral-500">
                    <span className="text-black">Step 2</span>- Once the redemption amount is
                    finalized, you will have to complete the transaction through your broker
                    platform which is linked to your DEMAT account. On the 3rd working day post
                    confirming the liquidation (T+3 basis), the investor will have to place a Sell
                    Order through their Broker at the liquidation price and units confirmed in the
                    earlier step.
                </p>
                <p className="mb-4 text-neutral-500">
                    This order will be accepted from our side and once the order is matched on the
                    Stock Exchange, the units will be debited from your DEMAT account. You will
                    receive the funds in your account as per stock exchange regulations.
                </p>
                <p className="mb-4 text-neutral-500">
                    <span className="text-black">Important Note</span>: The price of the bond and
                    the redemption amount will be frozen irrespective of whether the transaction in
                    Step 3 is conducted or not through the broker platform. If you have missed
                    concluding the transaction at the designated time, you can contact our Customer
                    Support team and we will arrange for the transaction to be concluded on another
                    date at the same price and redemption amount frozen earlier.
                </p>
            </div> */}

            {/* <div className="mb-12">
                <h3 className="tracking--0.48px mb-6 text-4xl font-semibold leading-10 md:text-6xl">
                    For Market Linked Debentures
                </h3>
                <p className="mb-4 font-semibold">
                    Please follow the steps for Liquidating your MLD. If any step is pending, the
                    liquidation will remain incomplete:
                </p>
                <p className="mb-4 text-neutral-500">
                    <span className="text-black">Step 1</span> - Enter the units that you want to
                    liquidate and click on &apos;Request Quote&apos;. You can liquidate any number
                    of units up to a maximum of the total free units available. You will now get an
                    OTP on your Mobile and Email. Input the OTP to confirm your request. Once
                    confirmed, you will get a fresh quote for Liquidation.
                </p>{" "}
                <p className="mb-4 text-neutral-500">
                    <span className="text-black">Step 2</span> - You will receive a notification
                    once the fresh quote is ready, and you can complete the liquidation process by
                    logging in on the {ICM_NAME_FULL} platform. Navigate to &apos;My Recent
                    Transactions/Details&apos; on the asset that you are looking to liquidate. Click
                    on &apos;Quote Ready&apos; to check the fresh quote. You may accept the quote by
                    clicking on &apos;Liquidate Now&apos;. The quote will be confirmed based on
                    market movements. At this step, you are redirected to a new &apos;Liquidate
                    Now&apos; screen. This quote is visible on the landing/home screen, navigating
                    the &apos;Confirm Now&apos; button the quote will become invalid, and the
                    request will need to regenerate.
                </p>
                <p className="mb-4 text-neutral-500">
                    <span className="text-black">Step 3</span> - Once you click on &apos;Liquidate
                    Now&apos;, another OTP will be generated which you will receive on your Email
                    and Mobile. Once you input this OTP, Liquidation Screen will confirm the
                    liquidation price, the redemption amount will be finalized.
                </p>
                <p className="mb-4 text-neutral-500">
                    <span className="text-black">Step 4</span> - Once the redemption amount is
                    finalized, you will have to complete the transaction through your broker
                    platform which is linked to your DEMAT account. On the 3rd working day post
                    confirming the liquidation (T+3 basis), the investor will have to place a Sell
                    Order through their Broker at the liquidation price and units confirmed in the
                    earlier step.
                </p>
                <p className="mb-4 text-neutral-500">
                    This order will be accepted from our side and once the order is matched on the
                    Stock Exchange, the units will be debited from your DEMAT account. You will
                    receive the funds in your account as per stock exchange regulations.
                </p>
                <p className="mb-4 text-neutral-500">
                    <span className="text-black">Important Note</span>: The price of the MLD and the
                    redemption amount will be frozen irrespective of whether the transaction in Step
                    4 is conducted or not through the broker platform. If you have missed concluding
                    the transaction at the designated time, you can contact our Customer Support
                    team and we will arrange for the transaction to be concluded on another date at
                    the same price and redemption amount frozen earlier.
                </p>
            </div> */}

            {/* <div className="mb-12">
                <h3 className="tracking--0.48px mb-4 text-4xl font-semibold leading-10 md:text-6xl md:leading-[55px]">
                    Terms & Conditions – Keep SIP Running - Daily Lottery
                </h3>
                <p className="mb-4 text-lg font-semibold text-black">Eligibility</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            This offer is applicable only to registered users of {ICM_NAME_FULL} who
                            have an active SIP (Systematic Investment Plan) running on the platform
                            during the campaign period.
                        </li>
                        <li className="mb-1">
                            Participants become eligible for the lottery if they have made a SIP
                            payment on the previous day. The more SIP payments completed, the higher
                            the chances of winning in the draw
                        </li>
                        <li className="mb-1">
                            The offer is valid for users who have completed at least one successful
                            SIP transaction during the offer period.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Offer Period</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            The “Keep SIP Running – Daily Lottery” offer starts from 13th Oct 2025.
                        </li>
                        <li className="mb-1">
                            {ICM_NAME_FULL} reserves the right to modify or withdraw the offer at
                            any time without prior notice.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Daily Lottery</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            Users who continue their active SIPs during the offer period will
                            automatically be enrolled in the daily lottery.
                        </li>
                        <li className="mb-1">
                            Each successful SIP transaction during the offer period counts as one
                            entry for that day’s draw.
                        </li>
                        <li className="mb-1">
                            Winners will be selected through a random draw conducted by{" "}
                            {ICM_NAME_FULL}
                            or its authorized partner.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Rewards</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            Daily winners will receive a reward of up to <b>₹10,000</b>, which may
                            be distributed among multiple winners.
                        </li>
                        <li className="mb-1">
                            Users with multiple SIPs may receive rewards for more than one SIP and
                            stays eligible for all.
                        </li>
                        <li className="mb-1">
                            The reward amount and mode of disbursement (cashback, voucher, or
                            equivalent) will be communicated by {ICM_NAME_FULL}.
                        </li>
                        <li className="mb-1">
                            Rewards are non-transferable and cannot be exchanged for cash.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">
                    Winner Announcement & Communication
                </p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            {ICM_NAME_FULL}’s decision regarding winner selection and reward
                            disbursement will be final and binding.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">General Conditions</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            Users must ensure that their SIPs remain active and uninterrupted during
                            the offer period.
                        </li>
                        <li className="mb-1">
                            Any SIP cancellation, failure, or missed installment during the offer
                            period may disqualify the user from the daily draw.
                        </li>
                        <li className="mb-1">
                            {ICM_NAME_FULL} reserves the right to verify participant eligibility and
                            disqualify entries that do not meet the offer criteria.
                        </li>
                        <li className="mb-1">
                            This offer cannot be combined with any other ongoing promotion, unless
                            explicitly stated.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Disclaimer</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            {ICM_NAME_FULL} reserves the right to amend these terms and conditions
                            or terminate the offer at its discretion.
                        </li>
                    </ul>
                </div>
                <div className="mb-12">
                    <p className="text-neutral-500">
                        All standard Terms & Conditions of Digital Gold and Digital Silver purchases
                        apply.
                    </p>
                </div>
            </div> */}
            {/* <div className="mb-12">
                <h3 className="tracking--0.48px mb-4 text-4xl font-semibold leading-10 md:text-6xl md:leading-[55px]">
                    Terms & Conditions – Dhanteras 1.5% Bonus on Digital Gold & Silver
                </h3>
                <p className="mb-4 text-lg font-semibold text-black">Eligibility</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            This offer is valid only for{" "}
                            <b>first-time Digital Gold & Silver transactions</b> on {ICM_NAME_FULL}.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Offer Period</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            The offer is valid only on <b>18th October 2025</b>. Transactions
                            completed outside this date will not be eligible.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Minimum Investment</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            Users must save <b>₹10,000 or more</b> in a single transaction to be
                            eligible for the bonus.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Rewards</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            Eligible users will receive a <b>1.5% bonus</b> on their invested
                            amount, credited as Digital Gold or Silver in 2 working days.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Limit</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            The offer is limited to <b>one account per user</b>.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Redemption</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            Bonus Digital Gold or Silver can be <b>redeemed or used for purchase</b>{" "}
                            as per the platform’s standard terms.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Disqualification</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            {ICM_NAME_FULL} reserves the right to <b>disqualify users</b> who
                            violate these terms, use fraudulent accounts, or attempt multiple
                            sign-ups.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Modification & Termination</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            {ICM_NAME_FULL} reserves the right to{" "}
                            <b>modify, suspend, or terminate the offer</b> at any time without prior
                            notice.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">General</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            By participating, users agree to these terms and {ICM_NAME_FULL}’s{" "}
                            <b>general terms and conditions</b>.
                        </li>
                    </ul>
                </div>
            </div> */}
            {/* <div className="mb-12">
                <h3 className="tracking--0.48px mb-4 text-4xl font-semibold leading-10 md:text-6xl md:leading-[55px]">
                    Terms & Conditions – Dhanteras ₹11 Free Digital Gold Sign-Up Offer
                </h3>
                <p className="mb-4 text-lg font-semibold text-black">Eligibility</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            This offer is valid only for <b>first-time sign-ups</b> on the{" "}
                            {ICM_NAME_FULL} App.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Offer Period</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            The offer is valid only on <b>18th October 2025</b>.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Rewards</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            To receive <b>₹11 worth of Digital Gold</b> - the sign up user needs to
                            do a <b>transaction of ₹12 or more</b> and select the <b>DHANTERAS11</b>{" "}
                            code at checkout. You can sign up and claim this free digital gold only
                            till <b>31st Oct 2025</b>.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Limit</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            The offer is limited to <b>one account per user</b>.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Redemption</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            Digital Gold credited under this offer can be used for{" "}
                            <b>purchase or redemption</b> as per the platform’s standard Digital
                            Gold terms.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Disqualification</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            {ICM_NAME_FULL} reserves the right to <b>disqualify users</b> who
                            violate these terms, use fraudulent accounts, or attempt multiple
                            sign-ups.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">Modification & Termination</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            {ICM_NAME_FULL} reserves the right to{" "}
                            <b>modify, suspend, or terminate the offer</b> at any time without prior
                            notice.
                        </li>
                    </ul>
                </div>
                <p className="mb-4 text-lg font-semibold text-black">General</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ul className="mb-4 ml-6 list-disc">
                        <li className="mb-1">
                            By participating, users agree to these terms and {ICM_NAME_FULL}’s{" "}
                            <b>general terms and conditions</b>.
                        </li>
                    </ul>
                </div>
            </div> */}
            <div className="mb-4">
                <h2 className="tracking--0.48px mb-4 text-4xl font-semibold md:text-6xl">
                    Refunds
                </h2>
                <p className="font-semibold text-black">
                    All refunds will be processed within 7 working days. For any queries, please
                    write to{" "}
                    <a href={"mailto:" + ICM_MAIL} className="text-blue-500 underline">
                        {ICM_MAIL}
                    </a>
                    .
                </p>
            </div>

            <div className="mb-4">
                <h3 className="mb-4 text-2xl font-semibold">
                    Terms & Conditions for New Customer Offer
                </h3>
                <ul className="ml-6 list-disc text-neutral-500">
                    <li>
                        Customers are eligible to avail Offer benefit of {ICM_REFER_BENEFIT}% extra
                        returns on their 1st investment only if they have successfully verified
                        their KYC within 7 days of Sign Up. Please Note: The Offer benefit expires
                        after 30 days from successful KYC verification.
                    </li>
                    <li>The Offer benefit is applicable for IPO Investments.</li>
                    <li>
                        For customers with existing investments, the above offer benefit on their
                        First investment of ₹50,000.
                    </li>
                    <li>
                        The offer is not applicable for Special Sure Deals like Diwali, Holi etc.
                    </li>
                </ul>
            </div>

            <div className="mb-12">
                <h3 className="mb-4 text-2xl font-semibold">
                    Consent to receive marketing & transactional communications
                </h3>
                <p className="text-neutral-500">
                    Registered users confirm & acknowledge that by registering on our apps and
                    website, they give consent to {ICM_NAME_FULL} for sending promotional, marketing
                    & transactional communications to them regularly through email, whatsapp, sms,
                    phone call, and no such communication shall be deemed to be in violation of law.
                </p>
            </div>

            <div className="mb-12">
                <h2 className="tracking--0.48px md-4xl mb-4 font-semibold md:text-6xl">
                    Terms and Conditions:
                </h2>
                <p className="mb-4 text-neutral-500">
                    This document is an electronic record in terms of Information Technology Act,
                    2000 and rules made there under as applicable and the amended provisions
                    pertaining to electronic records in various statutes as amended by the
                    Information Technology Act, 2000. This electronic record is generated by a
                    computer system and does not require any physical or digital signatures. This
                    document is published in accordance with the provisions of Rule 3 (1) of the
                    Information Technology (Intermediaries guidelines) Rules, 2011 that require
                    publishing the rules and regulations, privacy policy and Terms and Conditions
                    for access or usage of www.{INCREDUNLISTED}.com website or its iOS and android
                    applications.
                </p>
                <p className="mb-4 text-neutral-500">
                    The domain name &lsquo;
                    <a href={`https://www.${INCREDUNLISTED}.com`} target="_blank">
                        www.{INCREDUNLISTED}.com
                    </a>
                    &rsquo; (hereinafter referred to as &quot;Website&quot; or &quot;the Site&quot;)
                    is operated by Alpha Fintech Pvt Limited and owned by ETA Fintech Pvt Limited
                    and/or its subsidiaries (&quot;Company&quot;, &quot;{ICM_NAME_FULL}&quot;,
                    &quot;we&quot;, &quot;us&quot;, &quot;{ICM_NAME_FULL}&quot;). Your access to the
                    Site is subject to the terms, conditions and disclaimers appearing on the Site
                    (&quot;Terms and Conditions&quot;), and all applicable laws. By accessing,
                    browsing and/or using the Site, you accept, without limitation or qualification,
                    the Terms and Conditions, which together with our privacy policy and any other
                    applicable policies which are incorporated herein by way of reference or
                    available by hyperlink on the Site, shall govern {ICM_NAME_FULL}&rsquo;s
                    relationship with you in relation to this Site. Accessing {ICM_NAME_FULL} on its
                    online technology platform through any medium, including but not limited to the
                    website, on mobile phones and such other devices, is also subject to these Terms
                    &amp; Conditions. These Terms &amp; Conditions supersede all previous oral and
                    written terms and conditions (if any) communicated to you and shall act as an
                    Agreement between {ICM_NAME_FULL} and users.
                </p>
                <p className="mb-4 text-neutral-500">
                    Minimum Age: You must be 18 years of age or older to use the Site. It is not
                    intended for those under the age of 18. You represent and warrant that you are
                    18 years of age or older and are fully able and competent to enter into, and
                    abide by, the contract created by the Terms and Conditions.
                </p>
                <p className="mb-4 text-neutral-500">
                    Terms and Conditions Cover All Users: By using the Site, you agree to be bound
                    by the Terms and Conditions, whether you are a &quot;visitor&quot; (which means
                    that you simply browse the Site) or you are a &quot;registered user&quot; (which
                    means that you have an Investment Account with the Site to avail the Services or
                    any part thereof, as provided on the Site). Each time you use the Site, the
                    current version of the Terms and Conditions will apply. Accordingly, when you
                    use the Site, you should check and review any changes since the last version.
                    Please review carefully all of the Site&apos;s Terms and Conditions before
                    agreeing to them and accessing the Site by reading through all of the sections
                    appearing below and reviewing all of the linked Terms and Conditions:
                </p>
                <p className="mb-4 text-lg font-semibold text-black">1.Definitions</p>
                <div className="mb-8 text-base text-neutral-500">
                    <ol className="mb-4 ml-6 list-decimal">
                        <li className="mb-1">
                            &quot;AMC&quot; shall mean and include Asset Management Company.
                        </li>
                        <li className="mb-1">
                            &quot;{ICM_NAME_FULL}&quot; or &quot;us&quot; or &quot;we&quot; or
                            &quot;our&quot; or &quot;{ICM_NAME_FULL}&quot; or &quot;Company&quot;
                            shall mean and refer to ETA Fintech Pvt Ltd. and its subsidiaries
                        </li>
                        <li className="mb-1">
                            &quot;Use&quot; or &quot;Using&quot; means to browse, access, view,
                            copy, availing Services or other benefit from using the Site;
                        </li>
                        <li className="mb-1">
                            Group Entities - Shall mean affiliates, holding and subsidiaries of ETA
                            Fintech Private Limited.
                        </li>
                        <li className="mb-1">
                            &quot;Services&quot; means the service of access to the distribution
                            network of {ICM_NAME_FULL} through its online technology platform for
                            the purchase, switch and redemptions of units of mutual funds listed on
                            the {ICM_NAME_FULL} Website by users, on the terms and conditions as
                            mentioned.
                        </li>
                        <li className="mb-1">
                            &quot;Force Majeure Event&quot; means any event due to any cause beyond
                            the reasonable control of {ICM_NAME_FULL}, including without
                            limitations, unavailability of any communication systems, breach, or
                            virus in the processes or payment or delivery mechanism, sabotage, fire,
                            flood, explosion, acts of god, civil commotion, strikes or industrial
                            action of any kind, riots, insurrection, war, acts of government,
                            computer hacking, unauthorised access to computer data and storage
                            devices, computer crashes, malfunctioning in the computer terminal or
                            the systems getting affected by any malicious, destructive or corrupting
                            code or program, mechanical or technical errors/failures or power shut
                            down, faults or failures in telecommunication etc.
                        </li>
                        <li className="mb-1">
                            &quot;The Site&quot; or &quot;Website&quot; or &quot;{ICM_NAME_FULL}{" "}
                            Website&quot; means www.{INCREDUNLISTED}.com which includes, any other
                            platform where the Site can be accessed from on mobile phones and such
                            other devices, like, mobile application (whether or not on android or
                            IOS) or any other platform as provided by {ICM_NAME_FULL}.
                        </li>
                        <li className="mb-1">
                            &quot;Registered User/Registered user/ registered user&quot; shall mean
                            and include the visitors who have Investment Account with the Site to
                            avail the Services or any part thereof, as provided on the Site.
                        </li>
                        <li className="mb-1">
                            &quot;SIP&quot; shall mean Systematic Investment Plans.
                        </li>
                        <li className="mb-1">&quot;NAV&quot; shall mean Net Asset Value.</li>
                        <li className="mb-1">
                            &quot;Account&quot; shall mean the account opened with {ICM_NAME_FULL}{" "}
                            by registered users, for use of the Site or making investment through
                            the Site.
                        </li>
                        <li className="mb-1">
                            &quot;Vendors&quot; shall mean all third-party service providers
                            employed by either {ICM_NAME_FULL} or AMCs to deliver Services to users.
                            Such vendors include, but are not limited to payment gateway provider,
                            web-based transactions aggregator etc. Website Use User acknowledges
                            that in accessing and using the Services offered by {ICM_NAME_FULL},
                            user may utilize the content and Services offered on the {ICM_NAME_FULL}{" "}
                            website. User agrees to follow the terms and conditions for the use of{" "}
                            {ICM_NAME_FULL} website as may be specified on the Site from time to
                            time. Notwithstanding such acceptance of the {ICM_NAME_FULL} website
                            Terms, user acknowledges and agrees to the following, that:
                        </li>
                        <li>
                            User Account will be activated after {ICM_NAME_FULL} completes the
                            verification process on the personal information provided at the time of
                            enrolment and in accordance with the.
                        </li>
                    </ol>
                    <ul className="ml-6 list-disc text-neutral-500">
                        <li>
                            Know Your Client (&quot;KYC&quot;) guidelines issued by the Securities
                            and Exchange Board of India (&quot;SEBI&quot;).
                        </li>
                        <li>
                            Common Account Number (&quot;CAN&quot;) requirements as prescribed by
                            AMCs and/or their vendors.
                        </li>
                    </ul>
                </div>
                <div className="mb-8 text-base text-neutral-500">
                    <ol className="mb-4 ml-6 list-decimal">
                        <li className="mb-1">
                            User shall not to copy, reproduce, sell, redistribute, publish, enter
                            into a database, display, perform, modify, transmit, license, create
                            derivatives from, transfer or in any way exploit any part of any
                            information, content, materials, services available from or through the
                            Site, except that which user may download for personal, non‐commercial
                            use.
                        </li>
                        <li className="mb-1">
                            User will not use the Site for any purpose that is unlawful, or
                            prohibited by these Terms. User also agree that user will not use the
                            Site in any manner that could damage, disable or impair the Site or
                            interfere with any other person&rsquo;s use or enjoyment of{" "}
                            {ICM_NAME_FULL} website.
                        </li>
                        <li className="mb-1">
                            The software and hardware underlying the Site as well as other internet
                            related software which are required for accessing the Site are the legal
                            property of the respective vendors. The permission given by{" "}
                            {ICM_NAME_FULL} to access the Websites will not convey any proprietary
                            or ownership rights in the above software/ hardware. User agree that
                            User shall not attempt to modify, translate, disassemble, decompile or
                            reverse engineer the software/hardware underlying the Site or create any
                            derivative product based on the software / hardware.
                        </li>
                        <li className="mb-1">
                            The data and information provided on the Site does not constitute advice
                            and shall not be relied upon by the user while making investment
                            decisions.
                        </li>
                        <li className="mb-1">
                            {ICM_NAME_FULL} does not, and is not obliged to, offer all mutual fund
                            schemes for investment. By limiting the number of schemes on the Site,{" "}
                            {ICM_NAME_FULL} does not make any representation as to the quality, bona
                            fides or nature of any AMC or mutual fund scheme, or any other
                            representation, warranty or guaranty, express or implied.
                        </li>
                        <li className="mb-1">
                            User agrees that the information and assistance provided on the{" "}
                            {ICM_NAME_FULL} website are true to the knowledge of {ICM_NAME_FULL} and
                            should not be construed as investment advice, and that {ICM_NAME_FULL}{" "}
                            shall have no liability for any discrepancy in any such information or
                            assistance.
                        </li>
                        <li className="mb-1">
                            {ICM_NAME_FULL} is not responsible for the availability of content or
                            other services on third party sites linked from the {ICM_NAME_FULL}{" "}
                            website. User agrees and is aware that access of hyperlinks to other
                            internet sites are at user&rsquo;s own risk and the content, accuracy,
                            opinions expressed, and other links provided by these sites are not
                            verified, monitored or endorsed by {ICM_NAME_FULL} in any way.{" "}
                            {ICM_NAME_FULL} does not make any warranties and expressly disclaims all
                            warranties express or implied, including without limitation, those of
                            merchantability and fitness for a particular purpose, title or non‐
                            infringement with respect to any information or services or products
                            that are available or advertised or sold through these third party
                            websites.
                        </li>
                        <li className="mb-1">
                            {ICM_NAME_FULL} has the absolute discretion to amend or supplement any
                            of the {ICM_NAME_FULL} website Terms at any time without prior notice
                            for such changes. Any such amendment shall be effective immediately. It
                            shall be User&rsquo;s responsibility to review these Terms and
                            Conditions periodically for any updates/changes.
                        </li>
                        <li className="mb-1">
                            An account may be created offline, without accessing the {ICM_NAME_FULL}{" "}
                            website. In the event user creates an investment account offline, user
                            understands and acknowledges that these Terms and Conditions for use of
                            the {ICM_NAME_FULL} website will continue to be applicable to user for
                            the use of the Services.
                        </li>
                        <li className="mb-1">
                            Mere use of the Website, shall be construed as your intent to contract
                            with us and shall constitute your binding obligations, with us.
                        </li>
                        <li className="mb-1">
                            User understands that it is user&rsquo;s responsibility to check the{" "}
                            {ICM_NAME_FULL} website Terms carefully before accessing or using or
                            transacting on our website.
                        </li>
                        <li className="mb-1">
                            As long as User complies with these Terms and Conditions, we grant user
                            a personal, non-exclusive, non-transferable, limited privilege to enter
                            and use the Site. User acknowledges and understands that use of the Site
                            shall be at your own risk and has the discretion of not using the Site.
                        </li>
                        <li>
                            {ICM_NAME_FULL} shall not be liable if any transaction does not fructify
                            or may not be completed or for any failure on part of the{" "}
                            {ICM_NAME_FULL} to perform any of its obligations under these terms and
                            conditions or those applicable specifically to its services/facilities
                            if performance is prevented, hindered or delayed by a Force Majeure
                            event and in such case its obligations shall be suspended for so long as
                            the Force Majeure event continues.
                        </li>
                        <li>
                            All information, content, materials, products (including, but not
                            limited to text, content, photographs, graphics, video and audio
                            content) on the {ICM_NAME_FULL} website is protected by copyright in the
                            favour of {ICM_NAME_FULL} under applicable copyright laws and is also
                            protected otherwise under general intellectual property law.
                        </li>
                        <li>
                            All information submitted by user to {ICM_NAME_FULL} whether through the{" "}
                            {ICM_NAME_FULL} website or otherwise shall be deemed to be the property
                            of {ICM_NAME_FULL}, and {ICM_NAME_FULL} shall be free to use any ideas,
                            concepts, know‐how or techniques provided by such users at the{" "}
                            {ICM_NAME_FULL} website, in any manner whatsoever.
                        </li>
                        <li>
                            Not all the products and services offered on {ICM_NAME_FULL}&rsquo;s
                            website are available in all geographic areas and user may not be
                            eligible for all the products or services offered by {ICM_NAME_FULL} on
                            the Site. {ICM_NAME_FULL} reserves the right to determine the
                            availability and eligibility for any product or service.
                        </li>
                    </ol>
                </div>
            </div>
        </section>
    );
};

export default TermsAndConditions;
